$(document).ready(function () {
    if ($('.js_slick_current_promotions').length) {
        $('.js_slick_current_promotions').each(function () {
            $(this).slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            infinite: true,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1.02,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    }


    if ($('.js__product_slider').length) {
        $('.js__product_slider').each(function () {
            $(this).slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: `<div class="arrow-prew-product"></div>`,
                nextArrow: `<div class="arrow-next-product"></div>`,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: false,
                            arrows: false,
                        }
                    }
                ]
            });
        });
    }

    function slickProblem(tabActive) {
        if (!$(`.js_block_tab_problem[data-tabBlock=${tabActive}]`).hasClass('js__slick_active')) {
            $(`.js_block_tab_problem[data-tabBlock=${tabActive}]`).slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: `<div class="arrow-prew-product"></div>`,
                nextArrow: `<div class="arrow-next-product"></div>`,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.02,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: false,
                    }
                }
                ]
            });

            $(`.js_block_tab_problem[data-tabBlock=${tabActive}]`).addClass('js__slick_active')
        }
    }

    window.slickProblem = slickProblem;

    if ($('.js_customer_reviews_list').length) {
        $('.js_customer_reviews_list').each(function () {
            $(this).slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: `<div class="arrow-prew-product"></div>`,
                nextArrow: `<div class="arrow-next-product"></div>`,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: false,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.02,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: false,
                    }
                }
                ]
            });
        });
    }

    if ($('.js_sevris_action_block').length) {
        $('.js_sevris_action_block').each(function () {
            $(this).slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: `<div class="arrow-prew-product"></div>`,
                nextArrow: `<div class="arrow-next-product"></div>`,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: false,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: false,
                    }
                }, {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 1.02,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: false,
                    }
                }
                ]
            });
        });
    }

    function benefitsList() {
        $('.js_benefits_list').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `<div class="arrow-prew"></div>`,
            nextArrow: `<div class="arrow-next"></div>`,
            dots: false,
        });
    }

    window.benefitsList = benefitsList;

    if ($('.js_benefits_list_cat').length) {
        $('.js_benefits_list_cat').each(function () {
            const count = $(this).attr('data-count');

            $(this).slick({
                infinite: true,
                slidesToShow: count <= 5 ? count : 5,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: `<div class="arrow-prew"></div>`,
                nextArrow: `<div class="arrow-next"></div>`,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: count <= 3 ? count : 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    }
                }, {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    }
                }
                ]
            });
        });
    }

    if ($('.js_slider_promotional_list').length) {
        $('.js_slider_promotional_list').each(function () {
            const count = $(this).attr('data-count');
            $(this).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: (count == 1) ? false : true,
                customPaging: function (slider, i) {
                    return `<button type="button" class="swiper_dots" role="tab" aria-selected="true"></button>`;
                },
            });
        });
    }

})